declare global {
  interface Window {
    __polarityTraceEnabled?: boolean;
    __polarityTraceEvents?: Array<Record<string, unknown>>;
    __polarityClearTrace?: () => void;
  }
}

let traceSequence = 0;

export function initializePolarityTrace(enabled: boolean): void {
  if (typeof window === "undefined") {
    return;
  }

  window.__polarityTraceEnabled = enabled;
  window.__polarityTraceEvents = [];
  traceSequence = 0;
  window.__polarityClearTrace = () => {
    window.__polarityTraceEvents = [];
    traceSequence = 0;
    if (window.__polarityTraceEnabled === true) {
      console.info("[polarity-trace]", { type: "trace_cleared" });
    }
  };

  if (enabled) {
    console.info("[polarity-trace]", { type: "trace_enabled" });
  }
}

export function tracePolarity(type: string, payload: Record<string, unknown> = {}): void {
  if (typeof window === "undefined" || window.__polarityTraceEnabled !== true) {
    return;
  }

  const event = {
    seq: ++traceSequence,
    type,
    timeMs: round(performance.now()),
    ...payload,
  };

  const traceEvents = window.__polarityTraceEvents ?? [];
  traceEvents.push(event);
  if (traceEvents.length > 600) {
    traceEvents.shift();
  }
  window.__polarityTraceEvents = traceEvents;

  console.info("[polarity-trace]", event);
}

function round(value: number): number {
  return Math.round(value * 10) / 10;
}
